module.exports = __webpack_public_path__ + "assets/img/ozmo_blanco.f815d373.svg";